/**
 * Публикации раздела «Новости» — единый источник для главной и /novosti-antologia.
 * category: antologia | promotions | vendor | blog | webinars | webinar-recordings
 */

import { blogList, blogPosts } from './blogPosts';

export const antologiaNewsItems = [
  {
    id: 'antologia-just-ai',
    category: 'antologia',
    title: 'Заключен партнерский договор с компанией Just AI',
    description:
      'Теперь в портфеле Антологии есть самые современные технологии корпоративной связи, АТС, омниканальности, сквозной аналитики и AI-речевой аналитики.',
    fullText:
      'Теперь в портфеле Антологии есть самые современные технологии корпоративной связи, АТС, омниканальности, сквозной аналитики и AI-речевой аналитики. Это партнерство открывает новые возможности для наших клиентов и расширяет спектр предоставляемых услуг.',
    image: '/images/just-ai-logo-dark.svg',
    date: 'Март 2026',
    publishedAt: '2026-03-01',
  },
  {
    id: 'antologia-uis',
    category: 'antologia',
    title: 'Заключен партнерский договор с компанией UIS',
    description:
      'Партнерство по направлению корпоративного искусственного интеллекта, продуктов: Jay Copilot, Jay Guard и Agent Platform.',
    fullText:
      'Партнерство по направлению корпоративного искусственного интеллекта, продуктов: Jay Copilot, Jay Guard и Agent Platform. Совместная работа позволит предложить рынку инновационные решения на основе AI-технологий.',
    image: '/images/logo-uis.svg',
    date: 'Октябрь 2025',
    publishedAt: '2025-10-01',
  },
  {
    id: 'antologia-kazan-dw',
    category: 'antologia',
    title: 'Диджитал неделя в Казани, сентябрь 2025 года',
    description:
      'Сергей Успенский, Генеральный директор ООО "Успенский Технологии" принял участие в форуме Диджитал неделя в Казани 2025',
    fullText:
      'Сергей Успенский, Генеральный директор ООО "Успенский Технологии" принял участие в форуме Диджитал неделя в Казани 2025. Большое внимание российские технологии вызывают у представителей стран БРИКС. Видим прямые возможности для экспорта технологий на рынок Узбекистана.',
    image: '/images/kazandigitalweek2025.jpg',
    date: 'Сентябрь 2025',
    publishedAt: '2025-09-01',
  },
  {
    id: 'antologia-rvf-2025',
    category: 'antologia',
    title: 'Российский венчурный форум 9-11 апреля 2025 года',
    description: 'Участие в судейском жюри в венчурной секции.',
    fullText:
      'Российский венчурный форум 9-11 апреля 2025 года. Участие в судейском жюри в венчурной секции. Генеральный директор Успенский Сергей прокомментировал: «Более 60% всех проектов на форуме связаны с искусственным интеллектом, высокий потенциал у Российских вендоров решить поставленные задачи по замещению иностранных платформ».',
    image: '/images/rvf2025.jpg',
    date: 'Апрель 2025',
    publishedAt: '2025-04-09',
  },
];

/** Акции и скидки — дополнять по мере появления материалов. */
export const promotionsItems = [];

/** Новости вендоров — релизы и анонсы партнёров (дубли API снимаются при merge). */
export const vendorNewsItems = [
  {
    id: 'vendor-selectel-justai-agents',
    category: 'vendor',
    title:
      'Selectel и Just AI: единая платформа для корпоративных AI-агентов',
    description:
      'Selectel и Just AI представили совместное решение для запуска корпоративных AI-проектов: платформа управления агентами плюс инфраструктура под любую модель развёртывания.',
    image: '/images/news/93b1d2ee-62ec-4d3e-81cc-1f59df420bef.png',
    date: '25 июня 2026',
    publishedAt: '2026-06-25',
    href: '/novosti-antologia/publikaciya/selectel-just-ai-korporativnye-ai-agenty',
    slug: 'selectel-just-ai-korporativnye-ai-agenty',
  },
];

/** Анонсы предстоящих вебинаров. */
export const webinarItems = [];

/** Записи прошедших вебинаров. */
export const webinarRecordingItems = [];

const blogPublicationItems = blogList.map((post) => {
  const detail = blogPosts[post.slug];
  return {
    id: `blog-${post.slug}`,
    category: 'blog',
    title: post.title,
    description: post.description,
    image: post.image,
    date: post.date,
    publishedAt: detail?.datePublishedISO || '2026-01-01',
    href: `/blog/${post.slug}`,
    slug: post.slug,
    readTime: post.readTime,
  };
});

export const allPublicationItems = [
  ...antologiaNewsItems,
  ...promotionsItems,
  ...vendorNewsItems,
  ...blogPublicationItems,
  ...webinarItems,
  ...webinarRecordingItems,
];
